<template>
  <div
    class="hero mt-10 p-4 sm:p-10 text-inverse text-sm rounded-xl flex flex-col items-start justify-between relative z-10 sm:max-h-[276px] sm:min-h-[276px]"
    :class="{
      'bg-black': imageUrl,
      'bg-gradient-to-l from-black to-[#6200BB] bg-brand': !imageUrl,
    }"
  >
    <!-- Background with image -->
    <transition name="hero-fade">
      <div
        v-if="imageUrl"
        class="bg-blur z-20 pointer-none absolute inset-0 overflow-hidden w-full h-full rounded-xl"
      >
        <img
          :src="imageUrl"
          class="object-cover w-full h-full absolute inset-0 z-10"
          loading="eager"
          alt="background image"
        >
        <div
          class="object-cover w-full h-full absolute inset-0  bg-gradient-to-br from-[rgba(0,0,0,0.25)] to-[rgba(0,0,0,0.75)] z-20 backdrop-blur-[14px]"
        />
      </div>
    </transition>
    <div class="flex flex-row justify-between  relative z-20 w-full mb-4">
      <NuxtLink
        v-if="returnLink"
        :to="returnLink.path"
        class="inline-flex cursor-pointer hover:underline flex-row items-center justify-start"
      >
        <AM3Icon
          color="white"
          size="md"
          type="chevron-left"
        />
        <span class="inline-block ml-2  whitespace-nowrap"> {{ returnLink.text }} </span>
      </NuxtLink>

      <slot name="top-right">
        <div class="min-h-9" />
      </slot>
    </div>

    <!-- the left-to-right flow of the main hero content -->
    <div class="flex flex-col gap-4 sm:gap-0 sm:flex-row sm:items-stretch sm:justify-between relative z-20 text-inverse w-full">
      <div
        class="flex flex-col justify-between "
        :class="!hasCenter && hasLeft ? 'w-full flex-grow' : '' "
      >
        <slot name="left" />
      </div>
      <div
        v-if="hasCenter"
        class="flex flex-col w-full "
      >
        <slot name="center" />
      </div>
      <div
        v-if="hasRight"
        class="sm:basis-[24rem]"
      >
        <slot name="right" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'

const slots = useSlots()
const hasCenter = !!slots.center
const hasRight = !!slots.right
const hasLeft = !!slots.left

// Define props using TypeScript interface
interface Props {
  returnLink: {
    path: string
    text: string | null
  }
  imageUrl?: string | null
}

// Define props with defaults and types
withDefaults(defineProps<Props>(), {
  imageUrl: null,
})
</script>

<style type="text/css" scoped>
.am3-avatar {
  background-color: theme("colors.brand");
  color: #fff;
}

.hero-fade-enter-active, .hero-fade-leave-active {
  transition: opacity 0.33s;
  background-color: #000;
}
.hero-fade-enter-from, .hero-fade-leave-to {
  opacity: 0;
}
</style>
